import i18n from '../i18n';

export const translateLanguage = (
  selector: string,
  locale: string,
  interpolate?: { [key: string]: string | undefined }
) => i18n.t(selector, { ...interpolate, locale });
